"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../assets/PPForm2.css");
var PPDropDown_1 = __importDefault(require("../PPDropDown/PPDropDown"));
var PPIconLink_1 = require("../PPIconLink");
var PPInput_1 = __importDefault(require("../PPInput"));
var PPModal_1 = __importDefault(require("../PPModal"));
var PPMultiSelect_1 = __importDefault(require("../PPMultiSelect/PPMultiSelect"));
var PPTextArea_1 = __importDefault(require("../PPTextArea"));
var PPTooltip_1 = __importDefault(require("../PPTooltip"));
var PPUploader_1 = require("../PPUploader/PPUploader");
;
;
var PPForm2 = function (props) {
    var _a, _b, _c, _d, _e, _g, _h, _j, _k;
    var _l = (0, react_1.useState)(props.fields), fields = _l[0], setFields = _l[1];
    (0, react_1.useEffect)(function () {
        props.updateFieldsOnChangeOrigin &&
            setFields(props.fields);
    }, [props.fields]);
    var convertFieldsToData = function (fields) {
        var result;
        switch (props.returnType) {
            case "object":
                result = {};
                fields.forEach(function (f) { result[f.name] = f.value; });
                return result;
            default:
                result = fields.map(function (f) { return { name: f.name, value: f.value }; });
                return result;
        }
    };
    var handleDropFile = function (file, field) {
        var files = field.value !== "" ? field.value : [];
        var event = {
            target: {
                name: field.name,
                value: file.length == 0 ? undefined : files.concat(file)
            }
        };
        onChange(event, field);
    };
    var onChange = function (event, field) {
        var _fields = fields;
        _fields = _fields.map(function (_f) {
            return _f.name === event.target.name ? __assign(__assign({}, _f), { value: event.target.value, errors: props.keepErrorsOnChange ? _f.errors : undefined }) : _f;
        });
        //Filter
        if (field.filter) {
            var newOptions_1 = field.filter.onChange(event.target.value);
            _fields = _fields.map(function (f) { var _a; return f.name === ((_a = field.filter) === null || _a === void 0 ? void 0 : _a.field) ? __assign(__assign({}, f), { options: newOptions_1, value: undefined }) : f; });
        }
        if (props.onChange) {
            props.onChange(convertFieldsToData(_fields));
        }
        setFields(_fields);
    };
    var submit = function () {
        var _fields = fields;
        var errors = [];
        _fields.forEach(function (f) {
            errors = [];
            try {
                if (!f.value) {
                    //required
                    f.required &&
                        errors.push("Campo obrigat\u00F3rio");
                }
                else {
                    //max
                    if (f.max && Number(f.value) > Number(f.max))
                        errors.push("O valor deve ser menor ou igual a ".concat(f.max));
                    //min
                    if (f.min && Number(f.value) < Number(f.min))
                        errors.push("O valor deve ser maior ou igual a ".concat(f.min));
                    //maxLength
                    if (f.maxLength) {
                        switch (f.type) {
                            case "multiselect":
                                if (f.value.length > f.maxLength)
                                    errors.push("No m\u00E1ximo ".concat(f.maxLength, " itens podem ser selecionados"));
                                break;
                            default:
                                if (f.value.toString().length > f.maxLength)
                                    errors.push("O comprimento deve ser menor ou igual a ".concat(f.maxLength));
                                break;
                        }
                    }
                    //minLength
                    if (f.minLength) {
                        switch (f.type) {
                            case "multiselect":
                                if (f.value.length < f.minLength)
                                    errors.push("No m\u00EDnimo ".concat(f.minLength, " itens devem ser selecionados"));
                                break;
                            default:
                                if (f.value.toString().length < f.minLength)
                                    errors.push("O comprimento deve ser maior ou igual a ".concat(f.minLength));
                                break;
                        }
                    }
                    //regex
                    if (f.regex) {
                        var regex = new RegExp(f.regex.exp);
                        !regex.test(f.value.toString()) &&
                            errors.push(f.regex.help);
                    }
                }
            }
            catch (error) {
                console.warn({ where: "formSubmit", error: error });
            }
            _fields = _fields.map(function (g) { return g.name === f.name ? __assign(__assign({}, g), { errors: errors.length > 0 ? errors : undefined }) : g; });
        });
        var _hasErrors = _fields.find(function (g) { return g.errors; }) !== undefined;
        var _dataToSubmit = {
            validated: !_hasErrors,
            data: convertFieldsToData(_fields)
        };
        props.onSubmit &&
            props.onSubmit(_dataToSubmit);
        setFields(_fields);
    };
    var mountErrors = function (errors) {
        return errors ? react_1.default.createElement(react_1.default.Fragment, null, errors.map(function (e, i) { return react_1.default.createElement("div", { key: i },
            react_1.default.createElement("i", { className: 'ppi ppi-x text-danger' }),
            " ",
            e); })) : undefined;
    };
    var _m = (0, react_1.useState)(false), showUploader = _m[0], setShowUploader = _m[1];
    var mountFilesNames = function (files, f) {
        var archives = files;
        return archives.map(function (file) {
            return react_1.default.createElement("div", { style: {
                    backgroundColor: '#fff',
                    display: 'flex',
                    padding: '10px',
                    borderRadius: '10px',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    margin: '5px',
                    maxWidth: '200px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                } },
                react_1.default.createElement(PPIconLink_1.PPIconLink, { icon: "ppi ppi-x", tooltip: "Remover", size: "small", color: "red", onClick: function () { removeFile(file.name, f); } }),
                file.name);
        });
    };
    var removeFile = function (fileName, field) {
        var _fields = fields;
        var _field = _fields.filter(function (_fi) { return _fi.name === field.name; });
        var files = _field[0].value.filter(function (_file) { return _file.name !== fileName; });
        var event = {
            target: {
                name: field.name,
                value: files
            }
        };
        onChange(event, field);
    };
    var mountListFiles = function (files) {
        return files.length > 0 ? react_1.default.createElement("div", null, files.map(function (file) { return react_1.default.createElement(react_1.default.Fragment, null,
            file.name,
            " ",
            react_1.default.createElement("br", null)); }))
            :
                '';
    };
    return (react_1.default.createElement("div", { className: "pp-form" }, !props.loading ?
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "fields" },
                fields
                    .map(function (f) { return __assign(__assign({}, f), { value: f.value || "" }); })
                    .map(function (f, i) {
                    if (!f.hidden) {
                        switch (f.type) {
                            case "multiselect":
                                return react_1.default.createElement(react_1.Fragment, { key: i },
                                    f.spanLeft && react_1.default.createElement("span", { style: { width: f.spanLeft } }),
                                    react_1.default.createElement(PPMultiSelect_1.default, { name: f.name, onChange: function (event) { return onChange(event, f); }, options: f.options || [], disabled: f.disabled, placeholder: f.placeholder, readOnly: f.readOnly || props.submitting, required: f.required, error: { show: (f.errors !== undefined), help: mountErrors(f.errors) }, title: f.title, width: f.width, openTrigger: f.openTrigger || "click" }),
                                    f.spanRight && react_1.default.createElement("span", { style: { width: f.spanRight } }));
                            case "dropdown":
                                return react_1.default.createElement(react_1.Fragment, { key: i },
                                    f.spanLeft && react_1.default.createElement("span", { style: { width: f.spanLeft } }),
                                    react_1.default.createElement(PPDropDown_1.default, { name: f.name, onChange: function (event) { return onChange(event, f); }, options: f.options || [], disabled: f.disabled, placeholder: f.placeholder, readOnly: f.readOnly || props.submitting, required: f.required, error: { show: (f.errors !== undefined), help: mountErrors(f.errors) }, title: f.title, width: f.width, value: f.value, openTrigger: f.openTrigger || "click" }),
                                    f.spanRight && react_1.default.createElement("span", { style: { width: f.spanRight } }));
                            case "textarea":
                                return react_1.default.createElement(react_1.Fragment, { key: i },
                                    f.spanLeft && react_1.default.createElement("span", { style: { width: f.spanLeft } }),
                                    react_1.default.createElement(PPTextArea_1.default, __assign({}, f, { onChange: function (event) { return onChange(event, f); }, error: { show: (f.errors !== undefined), help: mountErrors(f.errors) }, width: f.width, readOnly: f.readOnly || props.submitting, rows: f.rows, autoheight: f.autoheight })),
                                    f.spanRight && react_1.default.createElement("span", { style: { width: f.spanRight } }));
                            case "file":
                                return react_1.default.createElement(react_1.Fragment, { key: i },
                                    f.spanLeft && react_1.default.createElement("span", { style: { width: f.spanLeft } }),
                                    react_1.default.createElement("div", { style: { display: 'flex', width: f.width, alignItems: 'center', justifyContent: 'center' } },
                                        react_1.default.createElement(PPTooltip_1.default, { position: 'left', trigger: 'hover', content: f.value !== "" ? mountListFiles(f.value) : "" },
                                            react_1.default.createElement("button", { className: 'pp-button bg-grey', onClick: function () { setShowUploader(true); } }, "Anexar arquivo")),
                                        react_1.default.createElement(PPModal_1.default, { visible: showUploader, title: "Anexar", onClose: function () { setShowUploader(false); } },
                                            react_1.default.createElement(PPUploader_1.PPUploader, { onDropFile: function (file) {
                                                    handleDropFile(file, f);
                                                    setShowUploader(false);
                                                }, fileTypes: f.fileTypes, promptMessage: f.promptMessage, maxSize: f.maxSize, selectLabel: f.selectLabel }),
                                            f.value !== "" && f.value !== undefined
                                                &&
                                                    react_1.default.createElement("span", { style: { maxWidth: f.width } }, mountFilesNames(f.value, f)))),
                                    f.spanRight && react_1.default.createElement("span", { style: { width: f.spanRight } }));
                            default:
                                var options = f.options, openTrigger = f.openTrigger, regex = f.regex, spanLeft = f.spanLeft, spanRight = f.spanRight, filter = f.filter, _f = __rest(f, ["options", "openTrigger", "regex", "spanLeft", "spanRight", "filter"]);
                                return react_1.default.createElement(react_1.Fragment, { key: i },
                                    spanLeft && react_1.default.createElement("span", { style: { width: spanLeft } }),
                                    react_1.default.createElement(PPInput_1.default, __assign({}, _f, { type: f.type, onChange: function (event) { return onChange(event, f); }, readOnly: f.readOnly || props.submitting, error: { show: (f.errors !== undefined), help: mountErrors(f.errors) } })),
                                    spanRight && react_1.default.createElement("span", { style: { width: spanRight } }));
                        }
                    }
                    else {
                        return '';
                    }
                }),
                props.children),
            !((_a = props.functions) === null || _a === void 0 ? void 0 : _a.hideFunctions) &&
                react_1.default.createElement("div", { className: "functions" },
                    react_1.default.createElement("button", { className: 'pp-button', hidden: (_c = (_b = props.functions) === null || _b === void 0 ? void 0 : _b.submitButton) === null || _c === void 0 ? void 0 : _c.hide, disabled: ((_e = (_d = props.functions) === null || _d === void 0 ? void 0 : _d.submitButton) === null || _e === void 0 ? void 0 : _e.disabled) || props.submitting, onClick: function () { return props.onSubmit && submit(); } }, !props.submitting ?
                        react_1.default.createElement(react_1.default.Fragment, null, ((_h = (_g = props.functions) === null || _g === void 0 ? void 0 : _g.submitButton) === null || _h === void 0 ? void 0 : _h.label) || "Salvar")
                        : react_1.default.createElement("i", { className: 'ppi ppi-loading ppi-spin ppi-2x' })), (_k = (_j = props.functions) === null || _j === void 0 ? void 0 : _j.otherButtos) === null || _k === void 0 ? void 0 :
                    _k.map(function (b, i) {
                        return react_1.default.createElement("button", { key: i, hidden: b.hide, className: "pp-button bg-".concat(b.context || 'grey'), disabled: b.disabled || props.submitting, onClick: b.onClick }, b.label);
                    })))
        :
            react_1.default.createElement("div", { className: 'loading' },
                react_1.default.createElement("i", { className: 'ppi ppi-loading ppi-spin' }))));
};
exports.default = PPForm2;
